/**
 * The words of the HR screens review of 2026-10-07 for the government authorities and payroll
 * (human-resources, branch claude/project-thread-zydvz1-hr-gov-payroll). Kept beside the catalogue,
 * as the other HR rounds' words are, and spread into it.
 */
export const HR_GOV_PAYROLL_EN = {
    // human-resources-q7k8t41f: a run whose last day to upload is today.
    "gov_sa.mudad.clock.due_today": "Upload on Mudad today — {due} is the last day of the window. ⚠ 30 days after the pay day, to confirm.",
    // human-resources-q7k90djc: the salary files beside the month's ratio, on the alert's own clock.
    "gov_sa.mudad.overview.status.wps_file": "Wage protection · salary file",
    "gov_sa.mudad.overview.col.wps_file_standing": "Salary files",
    "gov_sa.mudad.overview.wps_file_standing.late": "Late on Mudad",
    "gov_sa.mudad.overview.wps_file_standing.due": "Waiting to go up",
    "gov_sa.mudad.overview.wps_file_standing.none": "Nothing waiting",
    "gov_sa.mudad.overview.col.wps_runs_late": "Runs late on Mudad",
    "gov_sa.mudad.overview.col.wps_runs_waiting": "Runs waiting for their file",
    // human-resources-q7k8q5vk: what was already due before the unit was switched on.
    "value.stage.before_adoption": "From before adoption",
    "gov_sa.gosi.worklist.col.late_days": "Late by",
    "gov_sa.gosi.worklist.emphasis.overdue": "Past its due day",
    "gov_sa.gosi.settings.col.adopted_on": "Tasks counted from",
    "gov_sa.gosi.settings.field.adoption_cutoff": "Count tasks from",
    "gov_sa.gosi.settings.field.adoption_cutoff.help": "What was already due before this day is shown for the record, never as late. Empty: the day the worklist first heard of your people.",
    "gov_sa.qiwa.worklist.col.before_adoption": "From before the adoption day",
    "gov_sa.qiwa.adoption.action": "Count Qiwa tasks from",
    "gov_sa.qiwa.adoption.field": "Count tasks from",
    "gov_sa.qiwa.adoption.help": "A contract or change from before this day is shown for the record, never as work waiting, and a refresh opens none for it. Empty: the day the worklist first heard of your people.",
};
export const HR_GOV_PAYROLL_AR = {
    "gov_sa.mudad.clock.due_today": "ارفع على مُدد اليوم — {due} آخر يوم في المهلة. ⚠ ثلاثون يومًا بعد يوم الصرف، للتأكيد.",
    "gov_sa.mudad.overview.status.wps_file": "حماية الأجور · ملف الرواتب",
    "gov_sa.mudad.overview.col.wps_file_standing": "ملفات الرواتب",
    "gov_sa.mudad.overview.wps_file_standing.late": "متأخر على مُدد",
    "gov_sa.mudad.overview.wps_file_standing.due": "بانتظار الرفع",
    "gov_sa.mudad.overview.wps_file_standing.none": "لا شيء بالانتظار",
    "gov_sa.mudad.overview.col.wps_runs_late": "مسيّرات متأخرة على مُدد",
    "gov_sa.mudad.overview.col.wps_runs_waiting": "مسيّرات بانتظار ملفها",
    "value.stage.before_adoption": "سابق لبدء العمل بالنظام",
    "gov_sa.gosi.worklist.col.late_days": "متأخر بمقدار",
    "gov_sa.gosi.worklist.emphasis.overdue": "تجاوز موعده",
    "gov_sa.gosi.settings.col.adopted_on": "تُحتسب المهام من",
    "gov_sa.gosi.settings.field.adoption_cutoff": "احتساب المهام من",
    "gov_sa.gosi.settings.field.adoption_cutoff.help": "ما كان مستحقًا قبل هذا اليوم يظهر للعلم فقط، ولا يُعدّ متأخرًا. فارغ: اليوم الذي عرفت فيه قائمة العمل موظّفيكم أول مرة.",
    "gov_sa.qiwa.worklist.col.before_adoption": "سابق ليوم بدء العمل بالنظام",
    "gov_sa.qiwa.adoption.action": "احتساب مهام قوى من",
    "gov_sa.qiwa.adoption.field": "احتساب المهام من",
    "gov_sa.qiwa.adoption.help": "العقد أو التغيير السابق لهذا اليوم يظهر للعلم فقط، ولا يُعدّ عملًا منتظرًا، ولا يفتح له التحديث مهمة. فارغ: اليوم الذي عرفت فيه قائمة العمل موظّفيكم أول مرة.",
};
//# sourceMappingURL=i18n-hr-gov-payroll.js.map